import React, { type JSX, type ReactNode } from "react"
import { Link, type LinkProps } from "@octopus-energy/coral/atoms"
import { type RenderOptionsProps } from "storyblok-rich-text-react-renderer-ts"

type MarkResolver = (children: ReactNode) => JSX.Element | null

// The TS library is not updated with the new resolvers LOL WHAT A TROLL
// I'll do a PR on their repo: https://github.com/dohomi/storyblok-rich-text-react-renderer-ts
type MissingResolvers = {
    subscript: MarkResolver
    superscript: MarkResolver
}

export function getMarkResolvers(
    color?: LinkProps["color"]
): RenderOptionsProps["markResolvers"] & MissingResolvers {
    return {
        bold: (children) => <strong>{children}</strong>,
        italic: (children) => <em>{children}</em>,
        link: (children, { href, target, linktype, anchor }) => {
            if (linktype === "email") {
                return (
                    <Link
                        color={color}
                        href={`mailto:${href}`}
                    >
                        {children}
                    </Link>
                )
            }

            if (linktype === "story") {
                return (
                    <Link
                        color={color}
                        href={anchor ? `${href}#${anchor}` : href}
                        target={target || undefined}
                    >
                        {children}
                    </Link>
                )
            }

            return (
                <Link
                    color={color}
                    href={href}
                    target={target || undefined}
                >
                    {children}
                </Link>
            )
        },
        subscript: (children) => <sub>{children}</sub>,
        superscript: (children) => <sup>{children}</sup>,
    }
}
